module.exports = __webpack_public_path__ + "img/10942678972571@2x.59e55bf4.jpg";